<template>
  <form class="p-2" @submit.prevent>
    <h1
      v-if="
        $store.getters['user/userEmail'] !== 'anonymous@pedalsure.com' ||
        signInEmail
      "
      class="sign-up-title"
    >
      Welcome
    </h1>
    <h1 v-else class="sign-up-title">Create your Pedalsure account</h1>

    <div v-if="!signInEmail && !signUpEmail" class="field">
      <div
        v-if="$store.getters['user/userEmail'] !== 'anonymous@pedalsure.com'"
      >
        <div class="is-size-7 mb-1 has-text-grey-dark">
          Just browsing? No problem. You can create an account later if you like
          what you see
        </div>
        <button
          class="button ps-button is-fullwidth mb-5"
          @click.prevent="guestLogin"
        >
          <span> Continue as our Guest </span>
          <span class="icon is-small">
            <font-awesome-icon :icon="['far', 'user-circle']" />
          </span>
        </button>
      </div>

      <div
        v-if="$store.getters['user/userEmail'] !== 'anonymous@pedalsure.com'"
        class="is-size-7 mb-1 has-text-grey-dark"
      >
        Alternatively, create an account so we can send you a copy of your
        personalised quote and speed up the process for the next time you
        return.
      </div>
      <div v-else class="is-size-7 mb-1 has-text-grey-dark">
        Before we take your payment details and personal information we need you
        to create your Pedalsure account so you can manage your policy.
      </div>
      <button
        class="button ps-button is-fullwidth mb-2"
        @click.prevent="fbGoogleLogin"
      >
        <span> Continue with Google </span>
        <span class="icon is-small">
          <font-awesome-icon :icon="['fab', 'google']" />
        </span>
      </button>

      <button
        class="button apple-button is-fullwidth mb-2"
        @click.prevent="fbAppleLogin"
      >
        <span> Continue with Apple </span>
        <span class="icon is-small" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M16.365 1.43c0 1.14-.417 2.2-1.11 2.98-.75.85-1.98 1.5-3.06 1.42-.13-1.09.42-2.24 1.09-2.98.74-.83 2.06-1.45 3.08-1.42zM20.5 17.2c-.55 1.27-.81 1.84-1.52 2.96-.99 1.57-2.39 3.52-4.12 3.53-1.54.02-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.02-3.06-1.78-4.05-3.35C-.02 15.9-.34 11.6 1.44 9.03c.99-1.44 2.55-2.28 4.02-2.28 1.5 0 2.44 1 3.68 1 1.2 0 1.93-1 3.67-1 1.31 0 2.7.71 3.69 1.94-3.24 1.78-2.71 6.4.99 8.51z"
            />
          </svg>
        </span>
      </button>

      <!-- Passwordless: email a one-time sign-in link -->
      <button
        v-if="magicMode === 'idle'"
        class="button is-fullwidth mb-2"
        data-test="login-magic-toggle"
        @click.prevent="openMagic"
      >
        <span> Email me a sign-in link </span>
      </button>

      <div v-else-if="magicMode === 'form'" class="mb-2">
        <div class="field">
          <label class="label">Email</label>
          <div class="control has-icons-left">
            <input
              v-model="magicEmail"
              type="email"
              class="input"
              placeholder="e.g. bobsmith@gmail.com"
              data-test="login-magic-input"
              @keyup.enter="sendLink"
            />
            <span class="icon is-small is-left">
              <font-awesome-icon :icon="['fa', 'envelope']" />
            </span>
          </div>
        </div>
        <button
          class="button ps-button is-fullwidth"
          data-test="login-magic-send"
          @click.prevent="sendLink"
        >
          Send sign-in link
        </button>
        <a class="is-size-7" @click.prevent="magicMode = 'idle'"> - back </a>
      </div>

      <div v-else-if="magicMode === 'sent'" class="mb-2 has-text-grey-dark">
        <p class="is-size-7">
          We've emailed a sign-in link to <strong>{{ magicEmail }}</strong
          >. Open it on this device to sign in.
        </p>
        <a class="is-size-7" @click.prevent="magicMode = 'form'">
          Use a different email
        </a>
      </div>

      <button
        class="button is-fullwidth mb-5"
        @click.prevent="signUpEmail = true"
      >
        <span> Register with email </span>
      </button>

      <!-- <div class="is-flex">
        <input v-model="emailMarketing" type="checkbox" />
        <span
          class="is-size-7 mb-1 has-text-grey-dark ml-2"
          data-test="terms-agreement"
        >
          We'd love to send you exclusive offers and news about Pedalsure. You
          can ask us to stop at any time. If you would prefer not to hear from
          us, please tick the box.
        </span>
      </div> -->

      <div class="is-size-7 mb-1 has-text-grey-dark">
        Already have an acount? Great to see you again! Please login below.
      </div>

      <button
        class="button is-fullwidth mb-2"
        data-test="custom-login-button"
        @click.prevent="signInEmail = true"
      >
        <span> Login with email </span>
      </button>
    </div>

    <div v-if="signInEmail && !isResetPassword">
      <div class="field">
        <label for="" class="label">Email</label>
        <div class="control has-icons-left">
          <input
            v-model="email"
            type="email"
            placeholder="e.g. bobsmith@gmail.com"
            class="input"
            data-test="login-email"
            required
          />
          <span class="icon is-small is-left">
            <font-awesome-icon :icon="['fa', 'envelope']" />
          </span>
        </div>
      </div>
      <div class="field">
        <label for="" class="label">Password</label>
        <div class="control has-icons-left">
          <input
            v-model="password"
            type="password"
            placeholder="*******"
            class="input"
            data-test="login-password"
            required
          />
          <span class="icon is-small is-left">
            <font-awesome-icon :icon="['fa', 'lock']" />
          </span>
        </div>
      </div>
      <button
        class="button ps-button is-fullwidth"
        data-test="login-btn"
        @click="submit"
      >
        Login
      </button>
      <br />
      <button
        class="button ps-button is-fullwidth"
        @click="isResetPassword = true"
      >
        Forgot Password?
      </button>
      <a @click.prevent="signInEmail = false"> - back </a>
    </div>

    <div v-if="signUpEmail">
      <RegisterFrom :redirect-url="redirectUrl" />
      <a @click.prevent="signUpEmail = false"> - back </a>
    </div>

    <div v-if="isResetPassword">
      <div class="field">
        <label for="" class="label">Email</label>
        <div class="control has-icons-left">
          <input
            v-model="email"
            type="email"
            placeholder="e.g. bobsmith@gmail.com"
            class="input"
            required
          />
          <span class="icon is-small is-left">
            <font-awesome-icon :icon="['fa', 'envelope']" />
          </span>
        </div>
      </div>
      <button class="button ps-button is-fullwidth" @click="resetPassword">
        Reset now
      </button>
      <a @click.prevent="isResetPassword = false"> - back </a>
    </div>
    <div class="by-clicking">
      By clicking above you are accepting the Pedalsure terms of use and data
      policy. Click here to see our
      <a
        target="_blank"
        href="/documents/november_2026/Privacy_Policy_11-2026.pdf"
      >
        privacy policy
      </a>
    </div>
  </form>
</template>

<script>
/* eslint-disable no-console */
import { mapActions } from 'vuex'
import RegisterFrom from './RegisterForm'
import {
  auth,
  googleProvider,
  appleProvider,
  facebookProvider,
} from '~/services/firebase'
import { sendMagicLink } from '~/services/emailLink'
import { setAuthContext, clearAuthContext } from '~/services/authContext'

export default {
  name: 'LoginForm',
  components: { RegisterFrom },
  middleware: ['handle-login-route'],
  props: {
    redirectUrl: {
      type: String,
      default: '/dashboard',
    },
  },
  data() {
    return {
      email: '',
      password: '',
      signInEmail: false,
      signUpEmail: false,
      isResetPassword: false,
      emailMarketing: false,
      magicMode: 'idle', // idle | form | sent
      magicEmail: '',
    }
  },
  methods: {
    ...mapActions('user', ['login']),
    // Persist the destination before handing off to the provider — Firebase
    // opens its OAuth handler in a new tab on mobile and this one may not
    // survive. Nothing consumes this yet; see services/authContext.js.
    rememberDestination() {
      setAuthContext({ mode: 'login', redirectUrl: this.redirectUrl })
    },
    openMagic() {
      this.magicEmail = this.email
      this.magicMode = 'form'
    },
    async sendLink() {
      if (!this.magicEmail) {
        this.$toast.error('Please enter your email')
        return
      }
      try {
        this.$toast.show('Sending link...')
        await sendMagicLink(this.magicEmail, {
          mode: 'login',
          redirectUrl: this.redirectUrl,
        })
        this.$toast.clear()
        this.magicMode = 'sent'
      } catch (err) {
        console.log('magic link error', err)
        this.$toast.clear()
        this.$toast.error(
          `Could not send link${err && err.code ? `: ${err.code}` : ''}`
        )
      }
    },
    submit() {
      if (this.email !== '' && this.password !== '') {
        this.fbEmailPasswordLogin()
      } else {
        this.$toast.show('A email and password must be present')
      }
    },
    async fbEmailPasswordLogin() {
      try {
        const data = await auth.signInWithEmailAndPassword(
          this.email,
          this.password
        )
        await this.login({ data, emailMarketing: this.emailMarketing })
        this.$toast.clear()
        delete this.$route.query.nextUrl
        this.$router.push({
          path: this.redirectUrl,
          query: { ...this.$route.query },
        })
        this.$modal.hide('quick-quote')
        this.$gtm.push({
          event: 'login',
          provider: 'emailpassword',
        })
      } catch (err) {
        console.log('err', err)
        this.$toast.clear()
        this.$toast.error(`Error while login: Wrong email or/and password`)
      }
    },
    async fbGoogleLogin() {
      try {
        this.$toast.show('Logging in...')
        this.rememberDestination()
        const data = await auth.signInWithPopup(googleProvider)
        await this.login({ data, emailMarketing: this.emailMarketing })
        clearAuthContext()
        delete this.$route.query.nextUrl
        this.$router.push({
          path: this.redirectUrl,
          query: { ...this.$route.query },
        })
        this.$modal.hide('quick-quote')
        this.$gtm.push({
          event: 'login',
          provider: 'google',
        })
      } catch (err) {
        console.log('err', err)
        this.$toast.clear()
        this.$toast.error('Error while auth')
      }
    },
    async fbAppleLogin() {
      try {
        this.$toast.show('Logging in...')
        this.rememberDestination()
        const data = await auth.signInWithPopup(appleProvider)
        await this.login({ data, emailMarketing: this.emailMarketing })
        clearAuthContext()
        delete this.$route.query.nextUrl
        this.$router.push({
          path: this.redirectUrl,
          query: { ...this.$route.query },
        })
        this.$modal.hide('quick-quote')
        this.$gtm.push({
          event: 'login',
          provider: 'apple',
        })
      } catch (err) {
        console.log('err', err)
        this.$toast.clear()
        this.$toast.error(
          `Error while auth${err && err.code ? `: ${err.code}` : ''}`
        )
      }
    },
    async guestLogin() {
      try {
        const data = await auth.signInAnonymously()
        await this.login({ data, emailMarketing: this.emailMarketing })
        delete this.$route.query.nextUrl
        await this.$router.push({
          path: this.redirectUrl,
          query: { ...this.$route.query },
        })
        this.$modal.hide('quick-quote')
        this.$gtm.push({
          event: 'login',
          provider: 'anonymous',
        })
      } catch (err) {
        console.log('err', err)
        this.$toast.clear()
        this.$toast.error('Error while auth')
      }
    },
    async fbFacebookLogin() {
      try {
        this.$toast.show('Logging in...')
        this.rememberDestination()
        const data = await auth.signInWithPopup(facebookProvider)
        await this.login({ data, emailMarketing: this.emailMarketing })
        clearAuthContext()
        delete this.$route.query.nextUrl
        this.$router.push({
          path: this.redirectUrl,
          query: { ...this.$route.query },
        })
        this.$modal.hide('quick-quote')
        this.$toast.success('Successfully authenticated')
      } catch (err) {
        console.log('err', err)
        this.$toast.clear()
        this.$toast.error(err.message)
      }
    },
    async resetPassword() {
      try {
        if (this.email !== '') {
          this.$toast.show('Logging in...')
          console.log('w', window.location.origin)
          await auth.sendPasswordResetEmail(this.email, {
            url: `${window.location.origin}/login`,
          })
          this.$toast.clear()
          this.$toast.success('Email sent')
        } else {
          this.$toast.show('A email must be present')
        }
      } catch (err) {
        console.log('err', err)
        this.$toast.clear()
        this.$toast.error(
          'There is no user record corresponding to this email.'
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-login-button {
  width: 48%;
}
.sign-up-title {
  font-size: 2rem;
  color: $ps-primary;
  margin-bottom: 40px;
}
.button {
  // margin-bottom: 20px !important;
}
.button .icon {
  position: absolute;
  right: 25px;
}
.apple-button {
  background: #000;
  color: #fff;
  border-color: #000;

  &:hover,
  &:focus {
    background: #000;
    color: #fff;
  }

  .icon svg {
    width: 18px;
    height: 18px;
  }
}
.by-clicking {
  padding: 30px 0;
  font-size: 0.8rem;
  color: $grey-light;
  line-height: 1rem;
}
</style>
